import React, { useEffect } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import AppInput from "component/inputs/AppInput";
import TextField from "component/textField/TextField";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import { useGetCities, useGetLGA, useGetStates } from "api/queries/dashboard/misc";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";
import AppDatePicker from "component/inputs/datePicker/DatePicker";

const employerType = [
  {
    label: "Permanent",
    value: "permanent",
  },
  {
    label: "Self-employed",
    value: "self-employed",
  },
  {
    label: "Contract",
    value: "contract",
  },
  {
    label: "Part-time",
    value: "part-time",
  },
  {
    label: "Pensioner",
    value: "pensioner",
  },
  {
    label: "Student",
    value: "student",
  },
  {
    label: "Unemployed",
    value: "unemployed",
  },
];

const schemes = [
  {
    label: 'Outright Purchase',
    value: 'outright purchase'
  },
  {
    label: 'Off-Plan',
    value: 'Off-Plan'
  },
  {
    label: 'Equity Release',
    value: 'Equity Release'
  }
]
function EmployerDetails({trigger,formData,application, setValue, watch, errors, register }) {
  const { states, loading } = useGetStates();
  const { LGA, setStateID } = useGetLGA();
  const { cities, setStateID: setStateIdForCities } = useGetCities();

  const state = watch("employerState", "");
  const employmentDate = watch('employmentDate', '')

  useEffect(() => {
    const code = states?.find((_state)=>{
      return _state.name === state
    })?.state_code
    setStateID(code)
    setStateIdForCities(code)
  }, [state]);


  useEffect(() => {
    if (application.employerState) {
    
      setValue('employerState', application.employerState)
      setStateID(
        states?.find((_state) => {
          return _state.name === application.employerState;
        })?.state_code
      );
    }
  }, [states]);



  useEffect(() => {
    setValue("employerLga", application?.employerLga);
  }, [LGA]);

  useEffect(()=>{
    if(formData.employerPhone){
      trigger('employerPhone')
    }
  }, [formData.employerPhone])


  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Employer’s Details</Typography>
            <Typography>
              Please provide details of your current employer.
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                     setValue={setValue}
                     watch={watch}
                   required={true}
                    name="employerName"
                    errors={errors}
                    register={register}
                    label="Employer's Name"
                    type="text"
                    placeholder="Employer's Name"
                  />
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <LabeledSelect
                    errors={errors}
                    register={register}
                    data={schemes}
                    name="employerType"
                    label="Employer Type"
                    placeholder="Select Employer Type"
                  />
                </div>
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                     setValue={setValue}
                     watch={watch}
                   required={true}
                    name="employerIndustry"
                    errors={errors}
                    register={register}
                    label="Industry/Sector"
                    type="text"
                    placeholder="Industry name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                     setValue={setValue}
                     watch={watch}
                   required={true}
                    name="employerOccupation"
                    errors={errors}
                    register={register}
                    label="Occupation"
                    type="text"
                    placeholder="Banker"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <PhoneNumberInput
                    value={formData.employerPhone}
                    name="employerPhone"
                    errors={errors}
                    setValue={setValue}
                  />
                  {/* <TextField
                   required={true}
                    name="employerPhone"
                    errors={errors}
                    register={register}
                    label="Phone Number"
                    type="text"
                    placeholder="E.g +234 7849 9302"
                  /> */}
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                   required={true}
                    errors={errors}
                    register={register}
                    data={employerType}
                    name="employerType"
                    label="Employer Type"
                    placeholder="Select Employer Type"
                  />
                </div>
              </Grid> */}
             
              <Grid item xs={12} sm={12}>
                <div className={styles.field}>
                  <TextField
                   required={true}
                    name="employerAddress"
                    errors={errors}
                    register={register}
                    label="Address"
                    type="text"
                    placeholder="Insert Address"
                  />
                </div>
              </Grid>
             
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  
                  <LabeledSelect
                   required={true}
                    errors={errors}
                    register={register}
                    data={states?.map((state) => {
                      return {
                        label: state.name,
                        value: state.name,
                      };
                    })}
                    name="employerState"
                    label="State"
                    placeholder="Select State"
                  />
                </div>
              </Grid>{" "}
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                   required={true}
                    errors={errors}
                    register={register}
                    data={LGA?.map((state) => {
                      return {
                        label: state,
                        value: state,
                      };
                    })}
                    name="employerLga"
                    label="LGA"
                    placeholder="Select LGA"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <LabeledSelect
                      required={true}
                      name="employerCity"
                      register={register}
                      errors={errors}
                      label="City"
                      data={cities}
                      placeholder="Select City"
                    />
                
                </div>
              </Grid>{" "}
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <AppDatePicker
                    required={true}
                    errors={errors}
                    name="employmentDate"
                    label="Employment Date"
                    setValue={setValue}
                    value={employmentDate}
                    trigger={trigger}
                  />
                  {/* <TextField
                  dateMax
                   required={true}
                    name="employmentDate"
                    errors={errors}
                    register={register}
                    label="Employment Date"
                    type="date"
                  /> */}
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default EmployerDetails;